/* BB · Medición general (1-oct-2026, para el Cyber). Solo escucha y manda eventos a GA4:
   no cambia nada visible ni toca el flujo de compra. Todo va en try/catch y con listeners
   delegados en document, así que funciona aunque el componente no exista en la página.
   En vista previa del theme no manda a GA4: deja el registro en window.bbMedirRegistro.

   Eventos:
     bb_sl_view {modo, plantilla}          selector «Tipo de lente» presente en la ficha
     bb_sl_modo {modo, desde}              toque en una opción del selector
     bb_sl_aumento {}                      eligió un aumento (NO se manda el valor)
     bb_sl_bloqueo {}                      intentó agregar en Lectura sin aumento
     bb_sl_receta_cta {}                   «Continuar con tu receta»
     bb_sl_atc {modo}                      agregar al carro con el selector presente
     bb_barra_click {boton, modo}          barra fija: receta | carro
     bb_la_abrir {origen}                  se abre LensAdvisor (selector | barra | boton)
     bb_la_paso / bb_la_tipo / bb_la_metodo / bb_la_agregar / bb_la_cerrar   embudo de LensAdvisor (ver abajo)
     bb_medidas_abrir {}                   desplegó «Medidas»
     bb_carro_abrir {items}                se abre el carro lateral
     bb_carro_checkout {items}             «Pagar» en el carro lateral o en /cart
     bb_carro_quitar {}                    quitó un producto del carro
     bb_filtro {grupo, coleccion}          usó un filtro de colección
     bb_orden {valor, coleccion}           cambió el orden de la colección
     bb_menu_click {nivel, texto, destino} clic en el menú principal o mega menú
     bb_buscar_abrir {}                    abrió el buscador */
(function () {
  'use strict';
  if (window.bbMedir) return;
  window.bbMedir = true;
  window.bbMedirRegistro = window.bbMedirRegistro || [];
  var ultimaAperturaLa = 0;
  var preview = false;
  try { preview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'); } catch (e) {}

  function track(nombre, params) {
    try {
      params = params || {};
      window.bbMedirRegistro.push({ n: nombre, p: params, t: Date.now() });
      if (preview) return;
      var privacy = window.Shopify && Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
      if (typeof window.gtag === 'function') window.gtag('event', nombre, params);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: nombre }, params));
    } catch (e) {}
  }
  function txt(el, max) { try { return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, max || 40); } catch (e) { return ''; } }
  function cerca(el, sel) { try { return el && el.closest ? el.closest(sel) : null; } catch (e) { return null; } }
  function coleccion() { var m = /\/collections\/([^\/?#]+)/.exec(location.pathname); return m ? m[1] : ''; }
  function modoSl() {
    var t = document.querySelector('.bb-sl__tab.is-active, .bb-sl__tab[aria-checked="true"]');
    return t ? (t.getAttribute('data-mode') || '') : '';
  }
  /* Cohorte del A/B del selector en el carro, para leer conversión por orden (solo si el A/B corre). */
  var slEstampado = false;
  function estamparSl() {
    try {
      if (slEstampado || preview || !window.bbSlMedir || !window.bbSlCohorte) return;
      slEstampado = true;
      setTimeout(function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { bb_sl_cohorte: window.bbSlCohorte } }) }).catch(function () {});
      }, 2500);
    } catch (e) {}
  }
  function itemsCarro() { try { return document.querySelectorAll('#CartDrawer .cart__item').length; } catch (e) { return 0; } }

  /* --- selector «Tipo de lente»: vista (el JS del selector lo mueve y lo muestra tarde) --- */
  function vistaSelector(intentos) {
    try {
      var c = document.getElementById('BbSelectorLente');
      if (!c) return;
      if (c.style.display === 'none' && intentos > 0) { setTimeout(function () { vistaSelector(intentos - 1); }, 500); return; }
      var cuerpo = document.body.className || '';
      var p = /template-product[\w-]*/.exec(cuerpo);
      track('bb_sl_view', { cohorte_sl: window.bbSlCohorte || 'a', gratis: c.getAttribute('data-gratis') || '', modo: modoSl() || c.getAttribute('data-default-mode') || '', plantilla: (window.bbCohorte && window.bbCohorte.plantilla) || (p ? p[0] : '') });
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target, el;
      if ((el = cerca(t, '.bb-sl__tab'))) { track('bb_sl_modo', { modo: el.getAttribute('data-mode') || '', desde: modoSl(), cohorte_sl: window.bbSlCohorte || 'a' }); return; }
      if ((el = cerca(t, '.bb-sl__pill')) && !el.classList.contains('is-disabled')) { track('bb_sl_aumento', {}); return; }
      if (cerca(t, '.bb-sl__receta-cta')) { track('bb_sl_receta_cta', { cohorte_sl: window.bbSlCohorte || 'a' }); estamparSl(); ultimaAperturaLa = Date.now(); track('bb_la_abrir', { origen: 'selector' }); return; }
      if ((el = cerca(t, '.bb-sticky-v4__rx'))) { track('bb_barra_click', { boton: 'receta', modo: modoSl() }); ultimaAperturaLa = Date.now(); track('bb_la_abrir', { origen: 'barra' }); return; }
      if ((el = cerca(t, '.bb-sticky-v4__atc'))) { track('bb_barra_click', { boton: 'carro', modo: modoSl() }); return; }
      if (cerca(t, 'lensadvizor-btn, #la-select-lenses-btn, .la-select-lenses-btn')) { if (Date.now() - ultimaAperturaLa > 1500) track('bb_la_abrir', { origen: 'boton' }); return; }
      if ((el = cerca(t, '[name="checkout"]'))) { track('bb_carro_checkout', { items: itemsCarro(), donde: cerca(el, '#CartDrawer') ? 'lateral' : 'pagina' }); return; }
      if (cerca(t, '#CartDrawer .cart__remove, #CartDrawer [data-cart-remove], .cart__remove a')) { track('bb_carro_quitar', {}); return; }
      if (cerca(t, '.js-search-header, [data-predictive-search-button], .site-nav__link--icon[href*="/search"]')) { track('bb_buscar_abrir', {}); return; }
      if ((el = cerca(t, '.bb-megamenu a, .site-nav__dropdown a'))) { track('bb_menu_click', { nivel: 'sub', texto: txt(el), destino: (el.getAttribute('href') || '').slice(0, 80) }); return; }
      if ((el = cerca(t, 'a.site-nav__link')) && !cerca(el, '.site-nav__icons')) { track('bb_menu_click', { nivel: 'principal', texto: txt(el), destino: (el.getAttribute('href') || '').slice(0, 80) }); return; }
      if ((el = cerca(t, '.mobile-nav a'))) { track('bb_menu_click', { nivel: 'movil', texto: txt(el), destino: (el.getAttribute('href') || '').slice(0, 80) }); return; }
      if ((el = cerca(t, '.tag a, a.tag__link, .tag-list a')) && coleccion()) { var g0 = cerca(el, '.collection-sidebar__group'); track('bb_filtro', { grupo: g0 ? txt(g0.querySelector('.collapsible-trigger, .h5, h3, summary'), 30) : '', coleccion: coleccion() }); return; }
    } catch (err) {}
  }, true);

  document.addEventListener('change', function (e) {
    try {
      var t = e.target;
      if (t && t.id === 'SortBy') { track('bb_orden', { valor: t.value || '', coleccion: coleccion() }); return; }
      if (coleccion() && cerca(t, '.collection-sidebar, #FilterDrawer, .filter-form, [data-collection-filters]')) {
        var g = cerca(t, '.collection-sidebar__group');
        track('bb_filtro', { grupo: g ? txt(g.querySelector('.collapsible-trigger, .h5, h3, summary'), 30) : (t.name || '').slice(0, 30), coleccion: coleccion() });
      }
    } catch (err) {}
  }, true);

  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      if (!document.getElementById('BbSelectorLente')) return;
      var modo = modoSl();
      if (modo === 'lectura' && !document.querySelector('.bb-sl__pill.is-selected')) { track('bb_sl_bloqueo', {}); return; }
      track('bb_sl_atc', { modo: modo, cohorte_sl: window.bbSlCohorte || 'a' }); estamparSl();
    } catch (err) {}
  }, true);

  document.addEventListener('toggle', function (e) {
    try { if (e.target && e.target.matches && e.target.matches('[data-bb-medidas]') && e.target.open) track('bb_medidas_abrir', {}); } catch (err) {}
  }, true);

  function vigilarCarro() {
    try {
      var d = document.getElementById('CartDrawer');
      if (!d || !window.MutationObserver) return;
      var abierto = d.classList.contains('drawer--is-open');
      new MutationObserver(function () {
        var ahora = d.classList.contains('drawer--is-open');
        if (ahora && !abierto) setTimeout(function () { track('bb_carro_abrir', { items: itemsCarro() }); }, 800);
        abierto = ahora;
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }

  /* --- Embudo de LensAdvisor: en qué paso queda cada persona. Usa los eventos que la app
     documenta (lensadvisor.com/pages/developer). Solo se manda el NOMBRE del paso, el tipo de
     cristal y la forma de entregar la receta: nunca los valores de la receta.
       bb_la_paso {paso, n}            cada pantalla que se muestra (n = orden en esta apertura)
       bb_la_tipo {tipo_cristal}       monofocal | progresivo | lectura | neutro …
       bb_la_metodo {metodo}           uploaded | entered_manually | email_later | prescription_on_file
       bb_la_agregar {pasos, seg}      clic en agregar desde el resumen
       bb_la_cerrar {paso, pasos, seg, agrego}   cierre: último paso visto y si alcanzó a agregar */
  var la = { abierto: false, paso: '', n: 0, t0: 0, agrego: false };
  var PASOS = {
    'LensAdvizor:prescriptionTypes:rendered': '1_tipo_de_lente',
    'LensAdvizor:render:submissionMethods': '2_como_entrega_receta',
    'LensAdvizor:render:uploadForm': '3_sube_receta',
    'LensAdvizor:render:manualEntryForm': '3_escribe_receta',
    'LensAdvizor:lens:rendered': '4_elige_cristal',
    'LensAdvizor:lensOptions:rendered': '5_opciones_cristal',
    'LensAdvizor:addOns:rendered': '6_adicionales',
    'LensAdvizor:review:rendered': '7_resumen'
  };
  function seg() { return la.t0 ? Math.round((Date.now() - la.t0) / 1000) : 0; }
  function laAbrir() { la = { abierto: true, paso: '0_abre', n: 0, t0: Date.now(), agrego: false }; }
  function escucharLensAdvisor() {
    try {
      document.addEventListener('LensAdvizor:selectLensModal:open', laAbrir);
      Object.keys(PASOS).forEach(function (ev) {
        document.addEventListener(ev, function () {
          try {
            if (!la.abierto) laAbrir();
            if (la.paso === PASOS[ev]) return;
            la.paso = PASOS[ev]; la.n += 1;
            track('bb_la_paso', { paso: la.paso, n: la.n });
          } catch (e) {}
        });
      });
      document.addEventListener('LensAdvizor:selectLensModal:close', function () {
        try {
          if (!la.abierto) return;
          track('bb_la_cerrar', { paso: la.paso, pasos: la.n, seg: seg(), agrego: la.agrego ? 'si' : 'no' });
          la.abierto = false;
        } catch (e) {}
      });
      document.addEventListener('change', function (e) {
        try {
          var t = e.target;
          if (!la.abierto || !t || !t.classList || !t.classList.contains('la-tap-select')) return;
          if (la.paso === '1_tipo_de_lente') {
            var lab = t.id ? document.querySelector('label[for="' + t.id + '"]') : cerca(t, 'label');
            var nodo = lab ? (lab.querySelector('h3, h4, strong, b, .la-title') || lab) : null;
            var nombre = nodo ? txt(nodo, 60) : '';
            var corte = /^(.+?[a-záéíóúñ])(?=[A-ZÁÉÍÓÚ][a-záéíóúñ]+\s)/.exec(nombre); /* «MonofocalesCorrige…» → «Monofocales» */
            if (corte) nombre = corte[1];
            nombre = nombre.slice(0, 30);
            track('bb_la_tipo', { tipo_cristal: nombre });
          } else if (la.paso === '2_como_entrega_receta') {
            track('bb_la_metodo', { metodo: String(t.value || '').slice(0, 30) });
          }
        } catch (err) {}
      }, true);
      document.addEventListener('click', function (e) {
        try {
          if (!la.abierto || la.paso !== '7_resumen') return;
          var b = cerca(e.target, '#lensadvizor-prescription-modal button');
          if (b && /agregar|añadir|add|carro|carrito/i.test(b.textContent || '')) { la.agrego = true; track('bb_la_agregar', { pasos: la.n, seg: seg() }); }
        } catch (err) {}
      }, true);
    } catch (e) {}
  }

  function iniciar() { vistaSelector(8); vigilarCarro(); escucharLensAdvisor(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
